import Swiper from "swiper";
import Global from "./global";

class Bulider{
    constructor() {
        this.glob = new Global();
        this.s_slider = document.querySelector('.section_slider') ? document.querySelectorAll('.section_slider') : false;
        this.s_accor  = document.querySelector('.section_accordeon') ? document.querySelectorAll('.section_accordeon') : false;
        this.s_tab    = document.querySelector('.section_tab') ? document.querySelectorAll('.section_tab') : false;
        this.s_team   = document.querySelector('.section_team') ? document.querySelectorAll('.section_team') : false;
        this.s_slder_image = document.querySelector('.section_slider_image') ? document.querySelectorAll('.section_slider_image') : false;

        !this.s_slider || this.s_slider.forEach(el => this.sSlider(el));
        !this.s_accor  || this.s_accor.forEach(el => this.sAccordeon(el));
        !this.s_tab    || this.s_tab.forEach(el => this.sTab(el));
        !this.s_team   || this.s_team.forEach(el => this.sTeam(el));
        !this.s_slder_image || this.s_slder_image.forEach(el => this.sSliderImage(el));

    }

    sTeam(el){
        el.querySelectorAll('.item').forEach(item => {
            item.querySelector('.button_show').addEventListener('click', e => {
                let btn = item.querySelector('.button_show');
                if (btn.innerText === 'Read more') btn.innerText = 'See less';
                else btn.innerText = 'Read more';
                this.glob.slideToggle(item.querySelector('.hidden-text'));
            });
        });
    }

    sSliderImage(el){
        new Swiper(el.querySelector(".mySwiper"), {
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    sTab(el){
        el.querySelectorAll('.section_tab__tabs__flex .item').forEach(i => {
            i.addEventListener('click', e => {
                el.querySelectorAll('.section_tab__tabs__flex .item').forEach(it => it.classList.remove('active'));
                el.querySelectorAll(`.section_tab__contents .item`).forEach(item => item.classList.remove('active'));

                i.classList.add('active');
                el.querySelector(`.section_tab__contents .item[data-nr="${i.dataset.nr}"]`).classList.add('active');
            });
        })
    }

    sAccordeon(el){
        if (el.querySelector('.section_accordeon__nav')) {
            const btns = el.querySelectorAll('.section_accordeon__nav ul li');
            const boxes = el.querySelectorAll('.section_accordeon__box');

            btns.forEach(li => {
                const link = li.querySelector('button');

                link.addEventListener('click', e => {
                    e.preventDefault();
                    const id = link.dataset.id;

                    btns.forEach(item => {
                        const a = item.querySelector('button');
                        if (a) a.classList.remove('active');
                    });

                    boxes.forEach(box => box.classList.remove('active'));

                    link.classList.add('active');

                    const targetBox = el.querySelector(`.section_accordeon__box[data-id="${id}"]`);
                    if (targetBox) {
                        targetBox.classList.add('active');
                    }
                });
            });
        }


        el.querySelectorAll('.item').forEach(item => {
            item.querySelector('.item__header').addEventListener('click', e => {
                item.classList.toggle('active');
                this.glob.slideToggle(item.querySelector('.item__content'));
            });
        })
    }

    sSlider(el){
        new Swiper(el.querySelector(".mySwiper"), {
            loop:true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}

export default  Bulider;